import Util from "./Util.js";
import gsap from "./gsap.min";

export default class DialogBase {
  static EVENT_OPEN_BEFORE = "eventOpenBefore";
  static EVENT_OPEN = "eventOpen";
  static EVENT_CLOSE = "eventClose";
  constructor(_target) {

    this.el = document.createElement("div");

    this.CL_DIALOG_OPEN_BA = "isDialogOpenBA";
    this.CL_DIALOG_OPEN = "isDialogOpen";

    this.target = document.querySelector(_target);

    this.easing = "power3.out";
    this.time = 0.3;

    this.isOpen = false;
    this.isLocked = false;

    this.html = document.querySelector("html");
    this.body = document.body;

    this.target.querySelectorAll('.js-dialog_close').forEach(el=>{
      el.addEventListener('click',this.onClickClose.bind(this));
    });

    this.isSp = false;
    const mediaQuery = window.matchMedia('(max-width: '+Util.BREAK_POINT+'px)');
    this.onMediaQueryOnChange(mediaQuery);
    mediaQuery.addEventListener('change',this.onMediaQueryOnChange.bind(this));
  }

  onMediaQueryOnChange(e){
    this.isSp = e.matches;
    if(!this.isOpen){
      gsap.set(this.target,{y:"",opacity:""});
    }
  }

  onClickClose(e){
    if (this.isLocked) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    this.onClose();
  }

  onOpen(){
    this.isOpen = true;
    this.scrollTop = Util.getScrollY();
    this.isHtmlOverflow = (this.html.style.overflow === "hidden");
    gsap.set(this.target,{
      display:"block",
      ...(this.isSp?{y:"100%"}:{opacity:0})
    });
    this.onOpenBefore();

    gsap.killTweensOf(this.target);

    gsap.to(this.target,{
      duration:this.time,
      ...(this.isSp?{y:0}:{opacity:1}),
      ease:this.easing,onComplete:()=>{
        this.onOpenAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN));
      }
    });

    if(!this.isHtmlOverflow){
      let p = Util.getWindowScrollWidth();
      this.html.style.overflow = "hidden";
      this.body.style.overflow = "hidden";
      this.body.style.paddingRight = p+"px";
    }
  }

  onClose(){
    this.onCloseBefore();

    gsap.killTweensOf(this.target);
    gsap.to(this.target,{
      duration:this.time,
      ...(this.isSp?{y:"100%"}:{opacity:0}),
      ease:this.easing,onComplete:()=>{
        gsap.set(this.target,{display:"none"});
        this.isOpen = false;

        if(!this.isHtmlOverflow){
          this.html.style.overflow = "";
          this.body.style.overflow = "";
          this.body.style.paddingRight = "";
        }

        this.onCloseAfter();
        this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_CLOSE));
      }
    });
  }

  onOpenBefore(){
    this.el.dispatchEvent(new CustomEvent(DialogBase.EVENT_OPEN_BEFORE));
    this.html.classList.add(this.CL_DIALOG_OPEN_BA);
  }
  onOpenAfter(){
    this.html.classList.add(this.CL_DIALOG_OPEN);
  }

  onCloseBefore(){
    this.html.classList.remove(this.CL_DIALOG_OPEN);
  }
  onCloseAfter(){
    this.html.classList.remove(this.CL_DIALOG_OPEN_BA);
  }

  // API呼び出し中は操作を止める
  lockDialog(scrollTargetSelector = null) {
    if (this.isLocked) return;
    this.isLocked = true;

    // 並び替え、絞り込み、閉じるの押下禁止
    this.target.querySelectorAll('input, button').forEach(el => {
      el.dataset.prevDisabled = el.disabled; // 元状態を保持
      el.disabled = true;
    });

    // スクロール禁止
    if (scrollTargetSelector instanceof HTMLElement) {
      this.scrollTarget = scrollTargetSelector;

      this.scrollTarget.dataset.prevOverflow = this.scrollTarget.style.overflow;
      this.scrollTarget.style.overflow = 'hidden';
    } else {
      this.scrollTarget = null;
    }

  }

  // API呼び出し完了後に操作解放
  unlockDialog() {
    // ① disabledを元に戻す
    this.target.querySelectorAll('input, button')
      .forEach(el => {
        if (el.dataset.prevDisabled !== undefined) {
          el.disabled = (el.dataset.prevDisabled === 'true');
          delete el.dataset.prevDisabled;
        } else {
          el.disabled = false;
        }
      });

    // ② スクロール戻す
    if (this.scrollTarget) {
      this.scrollTarget.style.overflow = this.scrollTarget.dataset.prevOverflow || '';
      delete this.scrollTarget.dataset.prevOverflow;
      this.scrollTarget = null;
    }

    this.isLocked = false;
  }
}
